import React, { useEffect, useState } from 'react';

import { Spinner, Divider } from '@telus-uds/components-web';

import { TopbarWrapper } from '../../../css';
import request from '../../../../utils/request';

import Table from './components/Table';
import Add from './components/add';

const DomainWhitelist = () => {
  const [apiData, setApiData] = useState();

  const fetchData = async () => {
    try {
      const result = await request.get('/domains');

      if (result && result.status === 200) {
        setApiData(result.data);
      }
    } catch (err) {
      throw err;
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Divider space={2} variant={{ inverse: true }}/>
      {!apiData && <Spinner show label="Loading data..." />}
      {apiData && (
        <div>
          <Add fetchData={fetchData} />
          <TopbarWrapper style={{ color: '#fff', fontWeight: '900' }}>
            {`Domains Whitelist (${apiData.count})`}
          </TopbarWrapper>
          <Table data={apiData} fetchData={fetchData} />
          <Divider space={2} variant={{ inverse: true }}/>
        </div>
      )}
    </>
  );
};

export default DomainWhitelist;
